module.exports = __webpack_public_path__ + "img/PL00219.fc27a6d1.png";